import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import scrollIt from '../Base/Scroll';
import { debounce } from '../Helpers/helpers.js';
import { isMediumViewport } from '../Hooks/useMedia';
import useWindowLocationHref from '../Hooks/useWindowLocation';

const AnchorNavHorizontal = ({
  Links,
  currentActiveId,
  currentActiveMenuItem,
  translations,
}) => {
  const href = useWindowLocationHref();
  const isMobile = isMediumViewport();
  const [isFixed, setFixed] = useState(false);
  const [isExpanded, setExpandedMenu] = useState(false);

  const [lastActiveSectionID, setLastActiveSectionID] = useState('');
  const lastSectionRef = useRef({ id: '', offsetTop: 0, offsetHeight: 0 });

  const setExpandedMobileMenu = () => {
    if (isMobile) {
      setExpandedMenu(!isExpanded);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const element = document.querySelector('.horizontal-anchor-nav');
      if (element && element.getBoundingClientRect().bottom <= 80) {
        setFixed(true);
      } else {
        setFixed(false);
        setExpandedMenu(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (currentActiveId && currentActiveId !== lastActiveSectionID) {
      setLastActiveSectionID(currentActiveId);
    }
  }, [currentActiveId]);

  useEffect(() => {
    if (lastActiveSectionID) {
      const sectionElement = document.getElementById(lastActiveSectionID);

      if (!sectionElement) return;

      lastSectionRef.current = {
        id: lastActiveSectionID,
        offsetTop: sectionElement.offsetTop,
        offsetHeight: sectionElement.offsetHeight,
      };
    }
  }, [lastActiveSectionID]);

  useEffect(() => {
    const resetActiveSectionOnScroll = debounce(() => {
      if (!lastSectionRef.current) return;

      const { offsetTop, offsetHeight } = lastSectionRef.current;
      const scrollPosition = window.scrollY;
      const scrollOffset = 200;
      const upperBoundary = offsetTop - scrollOffset;
      const lowerBoundary = offsetTop + offsetHeight + scrollOffset;

      const scrolledOutsideActiveSection =
        scrollPosition < upperBoundary || scrollPosition > lowerBoundary;

      if (scrolledOutsideActiveSection) {
        setLastActiveSectionID('');
      }
    }, 100);

    window.addEventListener('scroll', resetActiveSectionOnScroll);
    return () => {
      window.removeEventListener('scroll', resetActiveSectionOnScroll);
    };
  }, [lastActiveSectionID]);

  return (
    <div className="horizontal-anchor-nav">
      <nav className="horizontal-anchor-nav__navigation" aria-hidden={isFixed}>
        <ul className="horizontal-anchor-nav__list">
          {Links &&
            Links.map((item, key) => {
              return (
                item.Id &&
                item.Name && (
                  <li key={key}>
                    <a
                      data-event-category={href || 'novalue'}
                      data-event-action={item.Name}
                      data-event-name="Horisontell Ankarlänk"
                      className={classNames({
                        'horizontal-anchor-nav__list__link': true,
                        'horizontal-anchor-nav__list__link--is-selected':
                          lastActiveSectionID === item.Id,
                      })}
                      onClick={() => {
                        setLastActiveSectionID(item.Id);
                        scrollIt(
                          document.getElementById(`${item.Id}`),
                          300,
                          'easeOutQuad',
                          () => {
                            if (typeof currentActiveMenuItem === 'function') {
                              currentActiveMenuItem(item.Id);
                            }
                          },
                          64
                        ),
                          setExpandedMobileMenu(!isExpanded);
                      }}
                      href={`#${item.Id}`}
                    >
                      <span data-event-include>{item.Name}</span>
                    </a>
                  </li>
                )
              );
            })}
        </ul>
      </nav>
      {/* This is a duplicated navigation only shown when navigation is fixed. 
      The navigation above needs to always be there to avoid 'jumping' document. 
      However the above navigation is set to 'aria-hidden=true' when not visible, so screen readers won't be affected */}
      {isFixed && (
        <nav className="horizontal-anchor-nav__navigation--is-fixed">
          <button
            className="horizontal-anchor-nav__mobile-expand"
            onClick={() => setExpandedMobileMenu(!isExpanded)}
            aria-label={translations?.anchorheadingmobile}
          >
            {translations?.anchorheadingmobile}{' '}
            <div className={`icon ${isExpanded ? 'expanded' : ''}`}></div>
          </button>
          <ul
            className={`horizontal-anchor-nav__list${
              isExpanded ? '--is-expanded' : ''
            }`}
            aria-label="undermeny"
            aria-expanded={`${isExpanded ? 'true' : 'false'}`}
          >
            {Links &&
              Links.map((item, key) => {
                return (
                  item.Id &&
                  item.Name && (
                    <li key={key}>
                      <a
                        data-event-category={href || 'novalue'}
                        data-event-action={item.Name}
                        data-event-name="Horisontell Ankarlänk"
                        className={classNames({
                          'horizontal-anchor-nav__list__link': true,
                          'horizontal-anchor-nav__list__link--is-selected':
                            lastActiveSectionID === item.Id,
                        })}
                        onClick={() => {
                          setLastActiveSectionID(item.Id);
                          scrollIt(
                            document.getElementById(`${item.Id}`),
                            300,
                            'easeOutQuad',
                            () => {
                              if (typeof currentActiveMenuItem === 'function') {
                                currentActiveMenuItem(item.Id);
                              }
                            },
                            64
                          ),
                            setExpandedMobileMenu(!isExpanded);
                        }}
                        href={`#${item.Id}`}
                      >
                        <span data-event-include>{item.Name}</span>
                      </a>
                    </li>
                  )
                );
              })}
          </ul>
        </nav>
      )}
    </div>
  );
};

export default AnchorNavHorizontal;
